"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapWithValues = exports.mapToRequest = exports.mapExtendedFieldValues = void 0;
var _commons = require("@focaltec-suite/commons");
var mapToRequest = exports.mapToRequest = function mapToRequest() {
  var extendedFields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var _a;
  var request = {};
  var _loop = function _loop() {
    var fieldId = _Object$keys[_i];
    var value = extendedFields[fieldId];
    var field = fields.find(function (el) {
      return el.id === fieldId;
    });
    var fixedValue = undefined;
    if (value) {
      switch ((_a = field === null || field === void 0 ? void 0 : field.type) !== null && _a !== void 0 ? _a : 'TEXT') {
        case 'DATE':
          fixedValue = (0, _commons.formatDate)({
            date: value
          });
          break;
        case 'DATETIME':
          fixedValue = (0, _commons.formatDateTime)({
            date: value
          });
          break;
        default:
          fixedValue = value;
      }
    }
    request[fieldId] = {
      id: fieldId,
      value: fixedValue
    };
  };
  for (var _i = 0, _Object$keys = Object.keys(extendedFields); _i < _Object$keys.length; _i++) {
    _loop();
  }
  return request;
};
var mapExtendedFieldValues = exports.mapExtendedFieldValues = function mapExtendedFieldValues(extendedFields, values) {
  var mapped = {};
  extendedFields === null || extendedFields === void 0 ? void 0 : extendedFields.items.forEach(function (extendedField) {
    var value = values ? values[extendedField.id] : undefined;
    if (!value) {
      value = {
        id: extendedField.id,
        value: value
      };
    }
    mapped[extendedField.id] = value;
  });
  return mapped;
};
var mapWithValues = exports.mapWithValues = function mapWithValues(extendedFields, current) {
  return extendedFields.map(function (extendedField) {
    var currentValue = current[extendedField.id];
    return {
      value: currentValue === null || currentValue === void 0 ? void 0 : currentValue.value,
      id: extendedField.id,
      field: extendedField
    };
  });
};